// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Extra indent for deeply nested order menu (Futures → Perpetual → links) */
body.light_theme .profile-sidebar-shell .order-sidebar-deep ul.btn-toggle-nav {
  /* margin-left: 4px; */
  padding-left: 0px;
  padding-top: 0px;
}

body.light_theme
  .profile-sidebar-shell
  .order-sidebar-deep
  .order-sidebar-deep
  ul.btn-toggle-nav {
  margin-left: 0px;
  padding-left: 0px;
}

/* Nested section toggles: align label column with top-level rows */
/* body.light_theme .profile-sidebar-shell .order-sidebar-subtoggle {
  padding-left: 8px !important;
} */

.profile-sidebar-shell .order-sidebar-spacer {
  display: inline-block;
  width: 22px;
  min-width: 22px;
  flex-shrink: 0;
}

.profile-sidebar-shell .navi_sidebar li.order-sidebar-deep .collapse li button {
  padding: 18px 32px;
}

.profile-sidebar-shell .navi_sidebar li.order-sidebar-deep .collapse li a {
  padding: 10px 32px;
}

@media (max-width: 991px) {
  .profile-sidebar-shell .navi_sidebar li.order-sidebar-deep .collapse li a {
    padding: 10px 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/customComponents/OrderSidebar/order-sidebar.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;EAKE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;;GAEG;;AAEH;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Extra indent for deeply nested order menu (Futures → Perpetual → links) */\nbody.light_theme .profile-sidebar-shell .order-sidebar-deep ul.btn-toggle-nav {\n  /* margin-left: 4px; */\n  padding-left: 0px;\n  padding-top: 0px;\n}\n\nbody.light_theme\n  .profile-sidebar-shell\n  .order-sidebar-deep\n  .order-sidebar-deep\n  ul.btn-toggle-nav {\n  margin-left: 0px;\n  padding-left: 0px;\n}\n\n/* Nested section toggles: align label column with top-level rows */\n/* body.light_theme .profile-sidebar-shell .order-sidebar-subtoggle {\n  padding-left: 8px !important;\n} */\n\n.profile-sidebar-shell .order-sidebar-spacer {\n  display: inline-block;\n  width: 22px;\n  min-width: 22px;\n  flex-shrink: 0;\n}\n\n.profile-sidebar-shell .navi_sidebar li.order-sidebar-deep .collapse li button {\n  padding: 18px 32px;\n}\n\n.profile-sidebar-shell .navi_sidebar li.order-sidebar-deep .collapse li a {\n  padding: 10px 32px;\n}\n\n@media (max-width: 991px) {\n  .profile-sidebar-shell .navi_sidebar li.order-sidebar-deep .collapse li a {\n    padding: 10px 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
